import React from "react";
import { useTranslation } from "react-i18next";
import AccordionSection from "./AccordionSection";

const MANTRA_SECTION_ORDER = [
  "sourceTruth",
  "oneStep",
  "antiHallucination",
  "revalidation",
  "referenceFiles",
  "fullPaths",
  "explicitCreation",
  "fullFileReturn",
  "layerSeparation",
  "decisionDoubt",
  "versioning",
  "systemObjectives",
  "gptWorkflow",
];

export default function MantraWindowContent() {
  const { t } = useTranslation("aiPortfolio");
  const [openSection, setOpenSection] = React.useState(MANTRA_SECTION_ORDER[0]);

  return (
    <div className="methodDoc mantraDoc" aria-label={t("mantraDoc.accordionAriaLabel")}>
      <p className="methodDocIntro">{t("mantraDoc.summary")}</p>

      {MANTRA_SECTION_ORDER.map((sectionKey) => {
        return (
          <AccordionSection
            key={sectionKey}
            sectionId={sectionKey}
            openSection={openSection}
            onOpenSection={setOpenSection}
            title={t(`mantraDoc.sections.${sectionKey}.title`)}
          >
            <ul>
              {t(`mantraDoc.sections.${sectionKey}.points`, { returnObjects: true }).map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </AccordionSection>
        );
      })}

      <p className="methodDocOutro">{t("mantraDoc.closing")}</p>
    </div>
  );
}
